import { Component, inject } from '@angular/core';
import { AnnouncementService } from '../../../services/announcement.service';
import { CustomSnackbarService } from '../../../services/custom-snackbar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingStore } from '../../../stores/loading.store';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-announcement-disable-modal',
  templateUrl: './announcement-disable-modal.component.html',
  styleUrls: ['./announcement-disable-modal.component.scss']
})
export class AnnouncementDisableModalComponent {
  private dialogRef = inject(MatDialogRef<AnnouncementDisableModalComponent>);
  private snackbarService = inject(CustomSnackbarService);
  private announcementService = inject(AnnouncementService);
  private loading = inject(LoadingStore);

  /**
   * Method to disable the current active announcement
   */
  async disableCurrentAnnouncement(): Promise<void> {
    try {
      this.loading.start();
      await this.announcementService.disableCurrentActiveAnnouncement().toPromise();
      this.closeModal(true);
    } catch (e) {
      if (e instanceof HttpErrorResponse) {
        this.snackbarService.showTranslatedError(e);
      }
    } finally {
      this.loading.stop();
    }
  }

  /**
   * Method to close the dialog
   * @param success whether the current announcement was successfully disabled
   */
  closeModal(success = false): void {
    this.dialogRef.close(success);
  }
}
